import { Button, Group, Stack } from '@mantine/core';
import { FC } from 'react';

import { Filter, FiltersTypes } from '../../data-access/types/filters';

import { ContainsFilterComponent } from './contains-filter';
import { DateRangeFilterComponent } from './date-range-filter';
import { NumberRangeFilterComponent } from './number-range-filter';
import { RangeSliderFilterComponent } from './range-slider-filter';
import { SelectFilter } from './select-filter';

import { useColFilters } from '@data-access';

type FiltersProps = {
  filters: Record<string, Filter>;
};

export const OrderFiltersMenu: FC<FiltersProps> = ({ filters }) => {
  const [, , resetFilters] = useColFilters('orders');
  return (
    <Stack>
      {Object.entries(filters).map(([name, filter]) => {
        switch (filter.filter_type) {
          case FiltersTypes.Select:
            return <SelectFilter key={name} {...filter} name={name} />;
          case FiltersTypes.Contains:
            return (
              <ContainsFilterComponent filter={filter} key={name} name={name} />
            );
          case FiltersTypes.DateRange:
            return (
              <DateRangeFilterComponent
                filter={filter}
                key={name}
                name={name}
              />
            );
          case FiltersTypes.NumberRange:
            return (
              <NumberRangeFilterComponent
                filter={filter}
                key={name}
                name={name}
              />
            );
          case FiltersTypes.RangeSlider:
            return (
              <RangeSliderFilterComponent
                filter={filter}
                key={name}
                name={name}
              />
            );
          default:
            return null;
        }
      })}
      <Group justify="start">
        <Button color="red" onClick={() => resetFilters()} variant="light">
          Reset Filters
        </Button>
      </Group>
    </Stack>
  );
};
